/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draganddropimageshereorclicktobrowse8Inputs */

const en_draganddropimageshereorclicktobrowse8 = /** @type {(inputs: Draganddropimageshereorclicktobrowse8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag and drop images here, or click to browse`)
};

const de_draganddropimageshereorclicktobrowse8 = /** @type {(inputs: Draganddropimageshereorclicktobrowse8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder hierher ziehen oder auswählen`)
};

/**
* | output |
* | --- |
* | "Drag and drop images here, or click to browse" |
*
* @param {Draganddropimageshereorclicktobrowse8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const draganddropimageshereorclicktobrowse8 = /** @type {((inputs?: Draganddropimageshereorclicktobrowse8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draganddropimageshereorclicktobrowse8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draganddropimageshereorclicktobrowse8(inputs)
	return de_draganddropimageshereorclicktobrowse8(inputs)
});
export { draganddropimageshereorclicktobrowse8 as "dragAndDropImagesHereOrClickToBrowse" }